<template>
  <b-container>
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
      <b-row>
        <b-col><b-form-input id="item-filter" v-model="itemname" placeholder="Item Search" @blur="fetchMenuItems()"></b-form-input></b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col>
          <h5 style="text-align: center;">Add new Item</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8">
          <b-form-input v-model="newItem.name" placeholder="Item name"></b-form-input>
        </b-col>
        <!-- <b-col cols="1">
          <label for="std-price" style="float: right;">$</label>
        </b-col> -->
        <b-col cols="4">
          <b-form-input id="std_price" v-model="newItem.std_price" placeholder="Price"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="py-2">
        <b-col cols="12">
          <b-form-input v-model="newItem.description" placeholder="Item description"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="py-2">
        <b-col cols="2"></b-col>
        <b-col cols="12">
          <b-form-input v-model="newItem.image_path" placeholder="Item image path"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="py-2">
        <b-col>
          <b-form-checkbox v-model="newItem.online" name="check-online" switch>Available online?</b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox v-model="newItem.on_premise" name="check-onpremise" switch>Available on premise?</b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="py-2">
        <b-col>
          <b-form-checkbox v-model="newItem.is_giftcard" name="check-giftcard" switch>Giftcard?</b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox v-model="newItem.allow_price_override" name="check-override" switch>Override Price?</b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="py-2">
        <b-col style="text-align:center;">
          <b-button variant="outline-dark" @click="addItem()">Add</b-button>
          <!-- <a :href="'#'+$route.path"><b-icon icon="plus-circle" variant="primary" font-scale="2.5" v-b-popover.hover.left="'Add new Item'" @click="addItem()"></b-icon></a> -->
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="10"><b-alert v-if="newitemalert" variant="info" v-model="newitemalert" dismissible>Please enter an Item name!</b-alert></b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <h5 style="text-align: center;">Edit Items</h5>
        </b-col>
      </b-row>
      <b-list-group>
        <ItemList
          v-for="item of items"
          v-bind:item="item"
          v-bind:key="item.id"
          @emit-fetch-items="fetchMenuItems"
          @emit-switch-overlay="switchOverlay">
        </ItemList>
      </b-list-group>
      <b-row>
        <b-col>
          <b-pagination v-model="currentPage" :total-rows="total_items" :per-page="limit" align="center" @change="showoverlay=true; fetchMenuItems()"></b-pagination>
          <p style="text-align: center;">Total items: {{ total_items }}</p>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
import ItemList from '@/components/ItemList.vue'
export default {
  name: "MenuItems",
  components: {
    ItemList
  },
  data() {
    return {
      items: [],
      total_items: 0,
      limit: 30,
      currentPage: 1,
      showoverlay: false,
      newItem: {
        name: '',
        description: '',
        image_path : '',
        std_price: '',
        online: true,
        on_premise: true,
        is_giftcard: false,
        allow_price_override: false
      },
      newitemalert: false,
      itemname: ''
    };
  },

  computed: {
    // all pagination, filtering and sorting info collected here for housekeeping purposes
    urlext: function() {
      return "?page="+this.currentPage+"&limit="+this.limit+this.itemfilter;
    },

    itemfilter: function() {
      if (this.itemname) {
        return '&name='+this.itemname;
      } else {
        return '';
      }
    }
  },

  methods: {

    switchOverlay(bool) {
      this.showoverlay = bool;
    },

    async addItem() {
      if (this.newItem.name == '') {
        this.newitemalert = true;
        return;
      }
      this.switchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "name": this.newItem.name,
        "description": this.newItem.description,
        "image_path": this.newItem.image_path,
        "std_price": this.newItem.std_price,
        "online": this.newItem.online,
        "on_premise": this.newItem.on_premise,
        "is_giftcard": this.newItem.is_giftcard,
        "allow_price_override": this.newItem.allow_price_override
      }
      // update order with status of 'ready'
      const { data } = await this.$api.post('items',
        body,
        config
      );
      if (data.created == true) {
        this.newItem = [];
        this.fetchMenuItems();
      } else {
        this.showoverlay=false;
        this.$bvModal.msgBoxOk('There was a problem adding the item, please try again later.', {
          title: 'Error adding item',
          centered: true
        })
      }
    },

    async fetchMenuItems() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("items"+this.urlext, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      try {
        this.items = await data.items;
        this.total_items = data.total_items;
        this.switchOverlay(false);
      } catch(e) {
        console.log(e);
        this.switchOverlay(false);
      }
    },

  },

  created: function() {
    // this.switchOverlay(true);
    this.fetchMenuItems();
  }
}
</script>
